$(document).ready(function(){
  
  $(".openMorePhoneNumbersOverlay span").on('click', function(){
    $('.morePhoneNumbers').css('display', 'none');
    
    $pnr = $(this).closest('.content').find('.morePhoneNumbers');
    
    $pnr.css('display', 'flex');
    
    $pncontainer =  $(this).closest('.content').find('.phoneNumbers');
    
    $pnr.css('margin-top', $pncontainer.position().top+'px');
    
  });
  
  
  $('.morePhoneNumbers .close').on('click', function(){
    $('.morePhoneNumbers').css('display', 'none');
  });
  
  $('.contactSalesLink').on('click', function(){
    pSendGAEvent('pt_contact_salesmail_click', {'pt_context': $(this).data('context')}, 'contact.js', 'contact.js: ga event gone wrong'); 
  });
  
  $('.contactSupportLink').on('click', function(){
    pSendGAEvent('pt_contact_supportmail_click', {'pt_context': $(this).data('context')}, 'contact.js', 'contact.js: ga event gone wrong'); 
  });
  
  
});